import { render, staticRenderFns } from "./HandlingShipping.vue?vue&type=template&id=007164dc&scoped=true&"
import script from "./HandlingShipping.vue?vue&type=script&lang=js&"
export * from "./HandlingShipping.vue?vue&type=script&lang=js&"
import style0 from "./HandlingShipping.vue?vue&type=style&index=0&id=007164dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007164dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
